exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ProfileEdit input[type=checkbox], .ProfileEdit input[type=radio] {\n  display: block; }\n\n.ProfileEdit .form-field label {\n  width: 30%;\n  display: inline-block; }\n\n.ProfileEdit .form-field input, .ProfileEdit .form-field .field-wrap {\n  display: inline-block;\n  width: 70%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/containers/ProfileEdit.scss
// module id = 587
// module chunks = 0